import React from "react";
import { Link } from "react-router-dom";

const categories = [
  { nombre: "Novedades", path: "/" },
  { nombre: "Hombres", path: "/hombres" },
  { nombre: "Mujeres", path: "/mujeres" },
  { nombre: "Accesorios", path: "/accesorios" },
  { nombre: "Ofertas", path: "/ofertas" }
];

const Categories = () => {
  return (
    <div className="flex gap-3 p-3 flex-wrap pr-4">
      {categories.map((cat, index) => (
        <Link
          key={index}
          to={cat.path}
          className="flex h-8 shrink-0 items-center justify-center gap-x-2 rounded-lg bg-[#f2f2f2] pl-4 pr-4"
        >
          <p className="text-[#141414] text-sm font-medium leading-normal">{cat.nombre}</p>
        </Link>
      ))}
    </div>
  );
};

export default Categories;
